<div class="user-rating">
  <div class="stars" *ngFor="let rate of stars">
    <mat-icon
      *ngIf="rate % 1 === 0 && rate <= rating"
      svgIcon="active_star"
      [class.cursor-pointer]="hasCursorPointer"
      (click)="setRating(rate)"
    ></mat-icon>
    <mat-icon
      *ngIf="rate % 1 !== 0"
      svgIcon="hulf_star"
      [class.cursor-pointer]="hasCursorPointer"
      (click)="setRating(rate)"
    ></mat-icon>
    <mat-icon
      *ngIf="rate > rating"
      svgIcon="noactive_star"
      [class.cursor-pointer]="hasCursorPointer"
      (click)="setRating(rate)"
    ></mat-icon>
  </div>
</div>
